/**
 * Fleet stats API Client (Strapi)
 */

import { getHttpClient } from '@spcc/core'

import type { FleetStats } from '../../domain/types'
import { STRAPI_ASSET_ENDPOINTS, validateFleetStats } from '../../api/api-types'
import { transformFleetStatsToDomain } from '../../api/transformers'

export const fleetApi = {
  async getFleetStats(): Promise<FleetStats> {
    const http = getHttpClient()
    const response = await http.get<unknown>(STRAPI_ASSET_ENDPOINTS.FLEET_STATS)
    const data = (response.data as { data?: unknown })?.data
    const validated = validateFleetStats(data)
    return transformFleetStatsToDomain(validated)
  },
}
